import { TextField } from "@mui/material";
import React from "react";

const BaseTextField = ({ sx = {}, ...props }) => (
  <TextField
    fullWidth
    margin="normal"
    sx={{
      "& .MuiOutlinedInput-root": { borderRadius: 2 },
      ...sx,
    }}
    {...props}
  />
);

export default BaseTextField;
